import { useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import '../styles/swiper-custom.css'

import SectionTitle from './ui/SectionTitle'
import Reveal from './ui/Reveal'
import Card from './ui/Card'

import sistema1Img from '../assets/images/sistema1.png'
import sistema2Img from '../assets/images/sistema2.png'
import sistema3Img from '../assets/images/sistema3.png'
import sistema4Img from '../assets/images/sistema4.png'
import sistema5Img from '../assets/images/sistema5.png'

const images = [
  sistema1Img,
  sistema2Img,
  sistema3Img,
  sistema4Img,
  sistema5Img,
]

const About = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const swiperRef = useRef(null)

  return (
    <section id="about" className="section-padding bg-gray-50 dark:bg-gray-800/50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.04]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(34, 198, 94, 0.06) 1px, transparent 0)',
        backgroundSize: '32px 32px',
      }} />
      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center w-full min-w-0">
          {/* Text Content */}
          <Reveal direction="right">
            <div className="space-y-4 sm:space-y-5">
              <SectionTitle
                title="Sobre Nós"
                subtitle="Quem Somos"
                align="left"
                className="mb-0"
              />
              <div className="space-y-4 text-sm sm:text-base text-gray-600 dark:text-gray-300 leading-relaxed">
                <p>
                  Somos uma empresa especializada em soluções de monitoramento de volume para diversos
                  setores industriais. Com tecnologia de ponta e expertise em medição, garantimos
                  precisão e eficiência no controle de seus reservatórios.
                </p>
                <blockquote className="text-base sm:text-lg font-bold text-gray-800 dark:text-gray-100 border-l-4 border-accent pl-4 py-2 my-4 italic">
                  Nossa missão é fornecer soluções inovadoras que permitam o monitoramento preciso e
                  em tempo real.
                </blockquote>
                <p>
                  Ajudando empresas a otimizar seus processos e reduzir perdas em volumes de produtos sólidos e líquidos.
                </p>
              </div>
            </div>
          </Reveal>

          {/* Swiper Carousel */}
          <Reveal direction="left" delay={200}>
            <Card padding="lg" hover={false} className="overflow-hidden max-w-full">
              <div className="swiper-container w-full">
                <Swiper
                  onSwiper={(sw) => { swiperRef.current = sw }}
                  onSlideChange={(sw) => setActiveIndex(sw.activeIndex)}
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={{ enabled: true }}
                  pagination={{ clickable: true, dynamicBullets: true }}
                  autoplay={{ delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                  loop={false}
                  watchOverflow={true}
                  className="rounded-xl w-full"
                  style={{ height: '300px', minHeight: '300px', width: '100%', maxWidth: '100%' }}
                  breakpoints={{
                    640: { height: '350px' },
                    768: { height: '400px' },
                    1024: { height: '450px' },
                  }}
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={index} className="!w-full">
                      <div className="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-gray-700/80 rounded-xl p-4 overflow-hidden">
                        <img
                          src={image}
                          alt={`Tela do sistema SysMV em uso - captura ${index + 1}`}
                          className="max-w-full max-h-full object-contain rounded-xl"
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = `https://via.placeholder.com/800x400/1a1a1a/00ff88?text=SysMV+${index + 1}`
                          }}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                {/* Thumbnails */}
                <div className="flex gap-2 mt-3 overflow-x-auto pb-1">
                  {images.map((image, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => swiperRef.current?.slideTo(index)}
                      className={`flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-xl overflow-hidden border-2 transition-all ${
                        activeIndex === index
                          ? 'border-accent ring-2 ring-accent/30'
                          : 'border-transparent dark:border-gray-600 opacity-70 hover:opacity-100'
                      }`}
                      aria-label={`Ver imagem ${index + 1}`}
                    >
                      <img
                        src={image}
                        alt=""
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </button>
                  ))}
                </div>
              </div>
            </Card>
          </Reveal>
        </div>
      </div>
    </section>
  )
}

export default About
